module.exports = __webpack_public_path__ + "static/media/othercancer.9b266b0b.svg";